module.exports = __webpack_public_path__ + "assets/img/14.9831cabd.png";